import React from 'react'
import useListCmsPaginatedFolders from 'hooks/useListCmsPaginatedFolders'
import FoldersBreadcrumb from 'pages/Cms/PagesList/FoldersBreadcrumb'
import { getFolderUuid, isContent } from 'pages/Cms/PagesList/utils'
import ListWrapper from 'redesign/components/organisms/ListWrapper'
import EmptyPage from 'redesign/components/organisms/empty-pages'
import { EMPTY_PAGE_VARIANTS } from 'redesign/components/organisms/empty-pages/constants'
import WikiCard from 'redesign/components/organisms/wiki-card'
import WikiCardFolder from 'redesign/components/organisms/wiki-folder-card'
import { CONTENT_TYPES } from 'types/cms'
import type { WikiPagesTemplateProps } from '../types'

const ContentWikiPagesWithFolders: React.FC<WikiPagesTemplateProps> = ({ ownerId }) => {
  const { list, loadMore, loading, hasMoreElements, currentFolder } = useListCmsPaginatedFolders({
    contentType: CONTENT_TYPES.page,
    ownerId,
    uuid: getFolderUuid(),
  })

  return (
    <ListWrapper
      loadMore={loadMore}
      showLoadMoreButton={hasMoreElements}
      isLoading={loading}
      hasContent={Boolean(list.length)}
      noContentBlock={<EmptyPage variant={EMPTY_PAGE_VARIANTS.noWiki} />}
    >
      {/* Placeholder, there is no redesign for this component */}
      <FoldersBreadcrumb isRedesign folder={currentFolder} />
      {list.map((folderEntry) => {
        const { content, folder } = folderEntry
        const isWikiContent = isContent(folderEntry)

        return isWikiContent ? (
          <WikiCard key={content?.uuid} content={content} />
        ) : (
          <WikiCardFolder key={folder?.uuid} ownerId={ownerId} folder={folder} />
        )
      })}
    </ListWrapper>
  )
}

export default ContentWikiPagesWithFolders
